import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setModal, selectModal } from "../../../redux/modalSlice";
import { useRequest } from '../../../hooks/UseRequest'
import { selectPaymentScheduleData } from '../../../redux/paymentScheduleDataSlice'
import { setNotification } from '../../../redux/notificationSlice'

export default function CancelLoanModal() {
  const dispatch = useDispatch();
  const modal = useSelector(selectModal);
  const customerId = modal.options?.customerId
  const loanId = modal.options?.loanId
  const request = useRequest()
  const [saving, setSaving] = useState(false)
  const paymentScheduleData = useSelector(selectPaymentScheduleData)

  const handleNo = async () => {
    dispatch(setModal({ is_active: false }));
  };

  const submitLoanCancellation = async () => {
    setSaving(true)
    request.setEndpoint(`${process.env.REACT_APP_API_DOMAIN}/customer/${customerId}/payment_schedule/cancellation`)
    try {
      let body = {}
      if (paymentScheduleData?.paymentScheduleCurrentDate !== null) {
        body.current_date = paymentScheduleData?.paymentScheduleCurrentDate;
      }

      if (loanId) {
        body.loan_id = loanId;
      }

      const response = await request.post(body)
      if (response.status === 200 || response.status === 201) {
        setSaving(false)
        dispatch(setNotification({ type: 'success', body: '' }))
        dispatch(setModal({ is_active: false }));
        modal.options?.successCallback()
        if (paymentScheduleData?.refreshPaymentSchedule !== null) {
          paymentScheduleData?.refreshPaymentSchedule()
        }
      } else {
        setSaving(false)
        dispatch(setNotification({ type: 'error', body: `Error: ${response.status}` }))
      }
    } catch (error) {
      setSaving(false)
      const errorMessage = error?.response?.data?.message ?? error?.response?.data?.messageExtreme
      dispatch(setNotification({ type: 'error', body: errorMessage }))
    }
  }

  return modal.is_active && modal.type === 'cancel_loan_modal' ? (
    <div className="modal is-active">
      <div className="modal-background"></div>
      <div className="modal-card column is-3">
        <header className="modal-card-head py-3">
          <p className="modal-card-title is-capitalized">Cancel Loan Confirmation</p>
          <button className="delete" aria-label="close" onClick={handleNo}></button>
        </header>
        <section
          className="modal-card-body modal-card-body pt-1 pb-1"
          style={{ minHeight: "30px", overflow: 'hidden' }}
        >
          <div className="columns mb-0 is-flex-direction-column">
            <div className="column">
              <h3>Are you sure you want to cancel the loan?<br />
                <i>Note: Cancellation will use ACH!</i><br /></h3>
            </div>
          </div>
        </section>
        <footer className="modal-card-foot is-justify-content-end py-1 pr-1">
          <div className="lox-form__buttons-wrapper has-text-right">
            <button type="button" className="button is-small has-background-grey has-text-white" onClick={handleNo}>No</button>
            <button type="submit" className="button is-danger is-small mx-1" onClick={submitLoanCancellation} disabled={saving}>Cancel Loan</button>
          </div>
        </footer>
      </div>
    </div>
  ) : null;
}
